import { css } from '@emotion/react'
import { Cell, Grid, HFlow, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { SubmitButton, TextField } from 'components/form'
import { Form, FormRenderProps } from 'components/form/final-form/Form/Form'
import { metaPath } from 'util/metaPath'
import { CadastrarDispositivoPainelChamadasModel } from 'view/chamada-painel/model-chamadaPainel'

import { cadastrarDispositivoPainelValidator } from '../validator-cadastrarDispositivoPainel'

interface CadastrarDispositivoPainelChamadasFormProps {
  onSubmit(values: CadastrarDispositivoPainelChamadasModel): Promise<void>
}

const meta = metaPath<CadastrarDispositivoPainelChamadasModel>()

export const CadastrarDispositivoPainelChamadasForm = (
  props: Readonly<CadastrarDispositivoPainelChamadasFormProps>
) => {
  const { onSubmit: handleSubmit } = props

  const renderForm = (formProps: FormRenderProps<CadastrarDispositivoPainelChamadasModel>) => {
    return (
      <Box style={styles.boxPopper}>
        <VFlow>
          <Grid>
            <Cell size={8}>
              <TextField
                name={meta.nome}
                label='Nome do dispositivo'
                placeholder='Informe um nome para identificar o dispositivo'
                required
                maxLength={50}
              />
            </Cell>
            <Cell size={4}>
              <TextField
                name={meta.codigo}
                label='Código'
                placeholder='Informe o código'
                required
                uppercase
                maxLength={4}
              />
            </Cell>
          </Grid>
          <HFlow justifyContent='flex-end'>
            <SubmitButton size='small' handleSubmit={formProps.handleSubmit}>
              Adicionar
            </SubmitButton>
          </HFlow>
        </VFlow>
      </Box>
    )
  }

  return (
    <Form<CadastrarDispositivoPainelChamadasModel>
      render={renderForm}
      onSubmit={handleSubmit}
      validate={cadastrarDispositivoPainelValidator}
    />
  )
}

const styles = {
  boxPopper: css`
    width: 40rem;
  `,
}
